export interface IBuildingDetail {
  building_shortcode?: string | null;
  language?: string | null;
  info_text?: string | null;
  facility_general?: string | null;
  facility_activities?: string | null;
  facility_services?: string | null;
  facility_internet?: string | null;
  facility_parking?: string | null;
  laundry_location?: string | null;
  rules_checkin?: string | null;
  rules_checkout?: string | null;
  rules_cancellation?: string | null;
  rules_children?: string | null;
  rules_warranty?: string | null;
  rules_pets?: string | null;
  rules_credit_cards?: string | null;
  info_text_new?: string | null;
}

export default class BuildingDetail {
  public buildingShortcode: string | null;
  public language: string | null;
  public infoText: string | null;
  public facilityGeneral: string | null;
  public facilityActivities: string | null;
  public facilityServices: string | null;
  public facilityInternet: string | null;
  public facilityParking: string | null;
  public laundryLocation: string | null;
  public rulesCheckin: string | null;
  public rulesCheckout: string | null;
  public rulesCancellation: string | null;
  public rulesChildren: string | null;
  public rulesWarranty: string | null;
  public rulesPets: string | null;
  public rulesCreditCards: string | null;
  public infoTextNew: string | null;

  constructor(data?: IBuildingDetail | null) {
    this.buildingShortcode = data?.building_shortcode ?? null;
    this.language = data?.language ?? null;
    this.infoText = data?.info_text ?? null;
    this.facilityGeneral = data?.facility_general ?? null;
    this.facilityActivities = data?.facility_activities ?? null;
    this.facilityServices = data?.facility_services ?? null;
    this.facilityInternet = data?.facility_internet ?? null;
    this.facilityParking = data?.facility_parking ?? null;
    this.laundryLocation = data?.laundry_location ?? null;
    this.rulesCheckin = data?.rules_checkin ?? null;
    this.rulesCheckout = data?.rules_checkout ?? null;
    this.rulesCancellation = data?.rules_cancellation ?? null;
    this.rulesChildren = data?.rules_children ?? null;
    this.rulesWarranty = data?.rules_warranty ?? null;
    this.rulesPets = data?.rules_pets ?? null;
    this.rulesCreditCards = data?.rules_credit_cards ?? null;
    this.infoTextNew = data?.info_text_new ?? null;
  }

  public toDTO(): IBuildingDetail {
    return {
      building_shortcode: this.buildingShortcode,
      language: this.language,
      info_text: this.infoText,
      facility_general: this.facilityGeneral,
      facility_activities: this.facilityActivities,
      facility_services: this.facilityServices,
      facility_internet: this.facilityInternet,
      facility_parking: this.facilityParking,
      laundry_location: this.laundryLocation,
      rules_checkin: this.rulesCheckin,
      rules_checkout: this.rulesCheckout,
      rules_cancellation: this.rulesCancellation,
      rules_children: this.rulesChildren,
      rules_warranty: this.rulesWarranty,
      rules_pets: this.rulesPets,
      rules_credit_cards: this.rulesCreditCards,
      info_text_new: this.infoTextNew
    };
  }
}
